import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, testid, dark = false }) => (
  <div className="mb-14 md:mb-20">
    <Reveal>
      <p
        className={`font-mono text-xs font-semibold uppercase tracking-[0.25em] sm:text-sm ${
          dark ? "text-[#9fd8b4]" : "text-[#2e7d4f]"
        }`}
      >
        {overline}
      </p>
    </Reveal>
    <Reveal delay={0.12}>
      <h2
        data-testid={testid}
        className={`mt-4 font-display text-3xl font-bold uppercase leading-none tracking-tight sm:text-4xl lg:text-5xl ${
          dark ? "text-[#f6f1e3]" : "text-[#1a2e22]"
        }`}
      >
        {title}
      </h2>
    </Reveal>
  </div>
);
